// Internal-only prop shared between Core.ButtonGroup and Button. Never pass this directly.
export const LEGACY_STYLE_PROP = '__legacyButtonStyle';
